module.exports = __webpack_public_path__ + "img/6c94b81.jpg";